function toggleCalculatorCategory(event) {
    if(dragging) return;

    var target = event.target.closest(".calculatorsListing .wrapper .tabs a");
    if(target) {
        event.preventDefault();
        event.stopPropagation();

        document.querySelector(".calculatorsListing .wrapper .tabs a.active").classList.remove("active");
        target.classList.add("active");

        document.querySelector(".calculatorsListing .wrapper .content .tab.active").classList.remove("active");
        document.querySelector(".calculatorsListing .wrapper .content .tab#" + target.getAttribute("data-id")).classList.add("active");
    }
}
document.addEventListener("click", toggleCalculatorCategory);
document.addEventListener("touchend", toggleCalculatorCategory);